import { ZomentumRoutes } from "@/Contracts";
import { EIcons } from "@atoms/ZIcon/interface";

export default () => {
	return [
		{
			title: "Marketplace",
			disabled: true,
			permission: null
		},
		{
			route: ZomentumRoutes.VendorMarketplaceProductListings,
			icon: EIcons.PACKAGE,
			title: "Products Collections",
			permission: null
		}
	];
};
